/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Chars_LabelInputs */



/**
* | output |
* | --- |
* | "Max Characters Per Line" |
*
* @param {Plain_Text_Import_Max_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_chars_label = /** @type {((inputs?: Plain_Text_Import_Max_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre max de caracteres par ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeichen pro Zeile")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di caratteri per riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество символов в строке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de caracteres por línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每行最大字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行あたりの最大文字数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति पंक्ति अधिकतम अक्षर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de caracteres por linha")
	return /** @type {LocalizedString} */ ("Max Characters Per Line")
});